import { State } from '../../types';

export const georgia: State = {
  name: 'Georgia',
  abbreviation: 'GA',
  terms: [
    {
      word: 'Albany',
      phonetic: 'ALL-binny',
      // audioUrl: '/audio/albany.mp3',
      description: 'A city in southwest Georgia, pronounced "ALL-binny," not like the New York capital "ALL-buh-nee."'
    },
    {
      word: 'Cairo',
      phonetic: 'KAY-roh',
      // audioUrl: '/audio/cairo.mp3',
      description: 'A city in Grady County, pronounced "KAY-roh," not like the Egyptian capital "KAI-roh."'
    },
    {
      word: 'Dacula',
      phonetic: 'Duh-CUE-la',
      // audioUrl: '/audio/dacula.mp3',
      description: 'A town often mispronounced by visitors.'
    },
    {
      word: 'Dahlonega',
      phonetic: 'Duh-LAW-na-ga',
      // audioUrl: '/audio/dahlonega.mp3',
      description: 'A historic town known for its gold rush history.'
    },
    {
      word: 'Decatur',
      phonetic: 'dih-KAY-ter',
      // audioUrl: '/audio/decatur.mp3',
      description: 'City in metro Atlanta.'
    },
    {
      word: 'DeKalb County',
      phonetic: 'duh-CAB',
      // audioUrl: '/audio/dekalb_county.mp3',
      description: 'The "L" is silent in this county name.'
    },
    {
      word: 'Gwinnett',
      phonetic: 'gwi-NET',
      // audioUrl: '/audio/gwinnett.mp3',
      description: 'The "i" is short, not long.'
    },
    {
      word: 'Hoschton',
      phonetic: 'HOOSH-tun',
      // audioUrl: '/audio/hoschton.mp3',
      description: 'Pronounced like "push" with an added syllable.'
    },
    {
      word: 'Houston County',
      phonetic: 'HOW-ston',
      // audioUrl: '/audio/houston_county.mp3',
      description: 'Pronounced differently than the Texas city.'
    },
    {
      word: 'Lafayette',
      phonetic: 'luh-FAY-it',
      // audioUrl: '/audio/lafayette.mp3',
      description: 'A city in northwest Georgia, pronounced "luh-FAY-it," not like the French "lah-fay-ET."'
    },
    {
      word: 'Martinez',
      phonetic: 'MAR-tin-ez',
      // audioUrl: '/audio/lafayette.mp3',
      description: 'A city in Columbia county often mispronounced as "mAR-teen-ez"'
    },
    {
      word: 'Ponce de Leon',
      phonetic: 'PAHNCE duh LEE-on',
      // audioUrl: '/audio/ponce_de_leon.mp3',
      description: 'A major avenue in Atlanta, pronounced "PAHNCE duh LEE-on," not "PAHN-say day LAY-on."'
    },
    {
      word: 'Senoia',
      phonetic: 'suh-NOY',
      // audioUrl: '/audio/senoia.mp3',
      description: 'A city in Coweta County, pronounced "suh-NOY," not "sen-OH-uh."'
    },
    {
      word: 'Taliaferro',
      phonetic: 'TOLL-iver',
      // audioUrl: '/audio/taliaferro.mp3',
      description: 'A county in Georgia, pronounced "TOLL-iver," not "tah-lee-ah-FER-oh."'
    },
    {
      word: 'Thames',
      phonetic: 'TAYMZ',
      // audioUrl: '/audio/thames.mp3',
      description: 'A street in Savannah, pronounced "TAYMZ," not like the English river "TEMZ."'
    },
    {
      word: 'Vidalia',
      phonetic: 'vie-DAY-lee-ah',
      // audioUrl: '/audio/vidalia.mp3',
      description: 'Famous for Vidalia onions.'
    }
  ]
};